import { render, staticRenderFns } from "./es-delete.vue?vue&type=template&id=10922542&scoped=true&"
import script from "./es-delete.vue?vue&type=script&lang=js&"
export * from "./es-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10922542",
  null
  
)

export default component.exports